"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var form_inner_card_1 = __importDefault(require("@hikakaku/shared/components/estimate_form/common/form_inner_card"));
var FormInnerCardStore = /** @class */ (function () {
    function FormInnerCardStore(props) {
        this.component = form_inner_card_1.default;
        this.elementStores = props.elementStores;
    }
    __decorate([
        mobx_1.observable,
        __metadata("design:type", Array)
    ], FormInnerCardStore.prototype, "elementStores", void 0);
    return FormInnerCardStore;
}());
exports.default = FormInnerCardStore;
